import React from "react";
import { StickerElement } from "../../types";

interface StickerEditingControlsProps {
  selectedSticker: StickerElement;
  onStickerUpdate: (id: string, updates: Partial<StickerElement>) => void;
}

const StickerEditingControls: React.FC<StickerEditingControlsProps> = ({
  selectedSticker,
  onStickerUpdate,
}) => {
  const handleFlipX = () => {
    onStickerUpdate(selectedSticker.id, {
      flipX: !(selectedSticker.flipX === true),
    });
  };

  const handleFlipY = () => {
    onStickerUpdate(selectedSticker.id, {
      flipY: !(selectedSticker.flipY === true),
    });
  };

  const handleRotationChange = (rotation: number) => {
    onStickerUpdate(selectedSticker.id, {
      rotation,
    });
  };

  const handleSizeChange = (width: number, height: number) => {
    onStickerUpdate(selectedSticker.id, {
      width,
      height,
    });
  };

  return (
    <div className="mt-6 p-4 bg-gray-50 rounded-lg border border-gray-200">
      <h4 className="font-semibold text-gray-700 mb-4 text-center" dir="rtl">
        עריכת סטיקר
      </h4>

      {/* Flip Controls */}
      <div className="mb-4">
        <label
          className="block text-sm font-medium text-gray-700 mb-2"
          dir="rtl"
        >
          היפוך
        </label>
        <div className="flex gap-2">
          <button
            onClick={handleFlipX}
            className={`flex-1 px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
              selectedSticker.flipX === true
                ? "bg-pink-500 text-white"
                : "bg-gray-200 text-gray-700 hover:bg-gray-300"
            }`}
            dir="rtl"
          >
            היפוך אופקי
          </button>
          <button
            onClick={handleFlipY}
            className={`flex-1 px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
              selectedSticker.flipY === true
                ? "bg-pink-500 text-white"
                : "bg-gray-200 text-gray-700 hover:bg-gray-300"
            }`}
            dir="rtl"
          >
            היפוך אנכי
          </button>
        </div>
      </div>

      {/* Rotation Control */}
      <div className="mb-4">
        <label
          className="block text-sm font-medium text-gray-700 mb-2"
          dir="rtl"
        >
          סיבוב: {Math.round(selectedSticker.rotation)}°
        </label>
        <input
          type="range"
          min="0"
          max="360"
          value={selectedSticker.rotation}
          onChange={(e) => handleRotationChange(Number(e.target.value))}
          className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer slider"
          style={{
            background: `linear-gradient(to right, #ec4899 0%, #ec4899 ${
              (selectedSticker.rotation / 360) * 100
            }%, #e5e7eb ${
              (selectedSticker.rotation / 360) * 100
            }%, #e5e7eb 100%)`,
          }}
        />
        <div className="flex justify-between text-xs text-gray-500 mt-1">
          <span>0°</span>
          <span>90°</span>
          <span>180°</span>
          <span>270°</span>
          <span>360°</span>
        </div>
      </div>

      {/* Quick Actions */}
      <div className="flex gap-2">
        <button
          onClick={() => {
            onStickerUpdate(selectedSticker.id, {
              flipX: false,
              flipY: false,
            });
          }}
          className="flex-1 px-3 py-2 bg-gray-200 text-gray-700 rounded-lg text-sm font-medium hover:bg-gray-300 transition-colors"
          dir="rtl"
        >
          איפוס היפוך
        </button>
      </div>
    </div>
  );
};

export default StickerEditingControls;
